import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'missingReceiptsExcelExport';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const missingReceiptsExcelExportActions = { ...slice.actions, ...extraActions };
export const missingReceiptsExcelExportReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        missingReceiptsExcelExport: {},
        //dashboardArgs: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/Dashboard`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async (postData)  => await fetchWrapper.post(`${baseUrl}/ExportMissingReceiptsToExcel`, {postData})
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.missingReceiptsExcelExport = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.missingReceiptsExcelExport = action.payload;
                // state.dashboardArgs = action.meta.arg;                
            },
            [rejected]: (state, action) => {
                state.missingReceiptsExcelExport = { error: action.error };
            }
        };
    }
}
